

// Header component
import {Link} from "react-router-dom";

const Header = () => (
    <header id="header">
        <Link to="../../public/index.html" className="logo">
            <strong>Džungla</strong> <span>Dječja Rođendaonica </span>
        </Link>
        <nav>
            <a href="/menu">Izbornik</a>
        </nav>
    </header>
);

export default Header;